import { Component, OnInit,TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_PM_Service_Interface, PM_Service_Interface } from 'src/app/Interface/PM_Service_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { PM_SubmitService } from 'src/app/Service/PM/PM_Submit.service';

@Component({
  selector: 'app-PMSubmitList',
  templateUrl: './PMSubmitList.component.html',
  styleUrls: ['./PMSubmitList.component.scss']
})
export class PMSubmitListComponent implements OnInit {
  Filter_Title: string = ""
  Filter_Description:string=''
  Filter_Manufacturer:string=''
  Filter_Model:string=''
  Filter_Code:string=''

  page: number = 0;
  Procssing: boolean = false

  modalRef_Delete: any;

  constructor(
    private PM_Submit_Service: PM_SubmitService,
    private Alertify_Service: AlertifyService,
    private Nav_Service: NavService,
    public router: Router,
    private modalService: BsModalService
  ) { }


  DataList_PM: Array<PM_Service_Interface> = []

  ngOnInit() {

    this.Nav_Service.CheckValidPage(1163).subscribe(
      data => {
        this.ReadData_PM()
      }
      , error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }

  ReadData_PM() {
    this.Procssing = true
    this.PM_Submit_Service.GetRecord().subscribe(
      data => {
        this.DataList_PM = data
        this.Procssing = false
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  Change_Filter() {
    this.page = 0
  }


  //#region PM Form

  Selected_PM_Record: PM_Service_Interface
  Selected_PM_Record_Switcher: string = 'List'
  Set_List_PM_View() {
    this.Selected_PM_Record_Switcher= 'List'
    this.ReadData_PM()
  }

  Set_Form_PM_View(item:PM_Service_Interface,Switcher:string) {
    this.Selected_PM_Record = item
    this.Selected_PM_Record_Switcher= Switcher
  }



  //#endregion

}
